import * as React from "react";
function SvgLines3V(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      ref={svgRef}
      {...props}
    >
      <path strokeWidth={2} stroke="currentColor" d="M0 1h20M0 10h20M0 19h20" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLines3V);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
